// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a[data-v-cc692dda],a[data-v-cc692dda]:link{color:#0062bd!important}.v-breadcrumbs[data-v-cc692dda]{padding:3px 20px;background:#f6f6f6}.ba-logo[data-v-cc692dda]{height:40px;position:relative;width:auto;left:120px;left:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
